import { useVideoCallStore } from "%/apps/video-engine/stores/video-call-store";
import { useGeneralStore } from "%/stores/general-store";

const POLL_INTERVAL_MS = 15000;

const subscribersByEventId = new Map();
let intervalId = null;

function pinnedOccurrenceFromUrl() {
  if (typeof window === "undefined") {
    return 0;
  }

  return Number(new URLSearchParams(window.location.search).get("occurrence")) || 0;
}

function refresh(eventId) {
  if (!useGeneralStore().isLoggedIn) {
    return;
  }
  useVideoCallStore().fetchEventPresence(eventId, () => {}, pinnedOccurrenceFromUrl());
}

function tick() {
  subscribersByEventId.forEach((subscribers, eventId) => {
    if (subscribers.size > 0) {
      refresh(eventId);
    }
  });
}

export function subscribeToEventPresence(eventId, subscriber) {
  const id = Number(eventId);
  if (!id || typeof window === "undefined") {
    return;
  }
  if (!subscribersByEventId.has(id)) {
    subscribersByEventId.set(id, new Set());
    refresh(id);
  }
  subscribersByEventId.get(id).add(subscriber);
  if (intervalId === null) {
    intervalId = window.setInterval(tick, POLL_INTERVAL_MS);
  }
}

export function unsubscribeFromEventPresence(eventId, subscriber) {
  const id = Number(eventId);
  const subscribers = subscribersByEventId.get(id);
  if (!subscribers) {
    return;
  }
  subscribers.delete(subscriber);
  if (subscribers.size === 0) {
    subscribersByEventId.delete(id);
  }
  if (subscribersByEventId.size === 0 && intervalId !== null) {
    window.clearInterval(intervalId);
    intervalId = null;
  }
}
